import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi.ts';
import { IEICFConsent, ISubmitEICFSignatureRequest } from '../EICFConsent.ts';

export function useSubmitEICFPhysicianSignature() {
  const queryClient = useQueryClient();
  return useMutation<IEICFConsent, AppMedError, ISubmitEICFSignatureRequest>({
    mutationKey: [QueryKeys.eicfPendingPhysicianConsents, 'physicianSign'],
    mutationFn: (req) => EICFConsentsApi.submitPhysicianSignature(req),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.eicfPendingPhysicianConsents],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.eicfSignedPhysicianConsents],
      });
    },
  });
}
